import React from 'react';
import { ConfigsTable } from './ConfigsTable';

export const ConfigList: React.FC = () => {
  return <ConfigsTable />;
};
